
import Vue from "vue";

export default Vue.extend({
  name: "SettlementSummaryChip",
  props: {
    label: { type: String, required: true },
    value: { type: String, default: "" },
  },
});
